import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Sidebar from '../components/Sidebar/Sidebar';
import Header from '../components/Header/Header';
import { newsService } from '../services/newsService';

const MainLayout: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isDesktopSidebarCollapsed, setIsDesktopSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      navigate('/');
    } else if (auth.isAuthenticated) {
      loadLayoutData();
    }
  }, [auth.isAuthenticated, auth.isLoading, navigate]);

  const loadLayoutData = async () => {
    setIsLoading(true);
    try {
      const newsData = await newsService.getAllNews();
      const unread = newsData.filter(item => !item.isRead).length;
      setUnreadCount(unread);
    } catch (error) {
      console.error('Erro ao carregar dados para o layout:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLinkClick = () => {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  };

  if (auth.isLoading || isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-100">
        <p className="text-lg font-medium text-gray-700">Carregando...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header onMenuButtonClick={() => setIsMobileMenuOpen(true)} />
      <div className="flex">
        {/* Desktop Sidebar */}
        <div className="hidden md:block">
          <Sidebar 
            unreadCount={unreadCount} 
            isCollapsed={isDesktopSidebarCollapsed}
            setIsCollapsed={setIsDesktopSidebarCollapsed}
            onLinkClick={handleLinkClick}
            isMobile={false}
          />
        </div>

        {/* Mobile Sidebar */}
        <div className={`fixed inset-0 z-40 flex md:hidden transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
          <Sidebar 
            unreadCount={unreadCount} 
            isCollapsed={false}
            setIsCollapsed={() => {}} // Not used in mobile view
            onLinkClick={handleLinkClick}
            isMobile={true}
          />
          <div 
            className={`flex-1 bg-black ${isMobileMenuOpen ? 'opacity-50' : 'opacity-0'}`}
            onClick={() => setIsMobileMenuOpen(false)}
          ></div>
        </div>

        <main className="flex-1 p-4 md:p-8 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
